<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Widgets</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_WIDGET_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add Widget</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control" placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by brand" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['lang']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by lang" class="form-control">
        @for (lang of languages; track lang.isoCode) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['type']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by type" class="form-control">
        @for (type of widgetTypes; track type) {
          <app-dropdown-select-option [value]="type.identifier">{{ type.label }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['userId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by author" class="form-control">
        @for (user of users; track user.id) {
          <app-dropdown-select-option [value]="user.id">{{ user }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th>Model</th>
          <th>S. Type</th>
          <th>S. Details</th>
          <th tableSorterHeader="site.product">Brand</th>
          <th tableSorterHeader="createdAt">Created</th>
          <th>Modified</th>
          <th tableSorterHeader="user">Author</th>
          <th tableSorterHeader="enabled">Status</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (widget of widgets; track widget.id) {
            <tr>
              <td>{{ widget.id }}</td>
              <td>{{ widget.name }}</td>
              <td>{{ widget.typeName }}</td>
              <td>{{ widget.options['sourceType'] }}</td>
              <td>{{ widget.options['sourceDetails'] }}</td>
              <td>{{ widget.site?.product }}</td>
              <td>{{ widget.createdAt | date:'dd MMM yyyy' }}</td>
              <td>{{ widget.updatedAt | date:'dd MMM yyyy' }}</td>
              <td>{{ widget.user }}</td>
              <td>
                @if (widget.enabled) {
                  <span class="badge bg-success"><i class="bi bi-check-circle me-2"></i>Active</span>
                } @else {
                  <span class="badge bg-danger"><i class="bi bi-x-circle me-2"></i>Disabled</span>
                }
              </td>
              <td class="text-end">
                @if (widget.scope === 'public' || ownsWidget(widget)) {
                  <a class="btn btn-outline-primary btn-sm" [routerLink]="[widget.id]">
                    <i class="bi bi-pencil me-1"></i>Edit
                  </a>
                  <button class="btn btn-outline-secondary btn-sm ms-1" appConfirm (click)="duplicate(widget)">
                    <i class="bi bi-copy me-1"></i>Duplicate
                  </button>
                } @else {
                  <div class="btn btn-outline-dark btn-sm disabled" style="width: 197px;">
                    <i class="bi bi-lock-fill me-1"></i>Protected
                  </div>
                }

                @if ((widget.scope === 'public' || ownsWidget(widget)) && widget.scope !== 'protected') {
                  @if (widget.scope === 'public') {
                    <button class="btn btn-outline-danger btn-sm ms-1" (click)="confirmDelete(widget)">
                      <i class="bi bi-trash"></i>
                    </button>
                  } @else {
                    <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(widget)">
                      <i class="bi bi-trash"></i>
                    </button>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
